export default __webpack_public_path__ + "static/media/November2009.b7a04985.png";